/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACY0lEQVR4nN1VO2hUURB9/gj4L/whirFR/BQWijayKEaW5M3nifedyQcSAi4WFhK0EWS1sVERwcIylY2iaGGlNnYqotiJiAqCIAgRv2hU5m12Dfo2u8mmEA9sMXfnnnlz75lzo+i/AYkdZrWfOb/BZvYz20pSe8ViNwuFwuy/Esrl8kxSu8NqL0kt5QSBFFdZMSKC9onJeQErHpPiYQhhft3EJOldxYp3rHbQ4xDCIha8YMHdEMKsvD2+ToobpHgtgtUNWyXBAKt9ZA7rPRbBThL7zoqhOvkXSO29SM+WhuS1lhVXSPGgVCrNqcR2mtW+dCXp5vF5seBIVpyNo8mgGMJSVrwhwYksLhbbWOyRn3G1KCliJyfFoWgqIIWw2jdK0h1ZFxw2ktgnL8psW1nxgRVnolbAgmEWPO3o6JuXxYohL8qKt6y45sprqUCmoky2uOixE7Lgtt9HHHcviaYDlNhuEoxyYl0euxRdyiQ4Py0FHE7ml54kfcuyWK2b1X548Wg6QIJjbhukuF5dY8ElPz4/xpbI2S3Dj0hxrnLBdsDXRfoXV7wHw1Mmj5N0WzbVglOVTuyky1MV635POUaZbf+kyYnC2mzYFJercnSXZLF7pLhfGzixsy7bzhBWNE1eLPYuZLEnThbH8dzx/6liw9jAHa/kFtvGnLR2PxPCv4zVbrHacyJbnpdTGzi27ZVubRMLPrtRNuKfkU2vYuRPY8t7O0jsWdX/WXHU93Xu61kT1YO3TWJfmdNdUQOIoN0Jsw/idE+s2Ouq8sK5FuKvmCuC1PqjJsFqg3nPrD+/zXL8+/gFA/YUXfiww+IAAAAASUVORK5CYII=)
 */
export const XNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.86 10.47 21.15 2h-1.73l-6.33 7.35L8.04 2H2.22l7.64 11.12L2.22 22h1.72l6.68-7.77L15.96 22h5.82l-7.92-11.53Zm-2.36 2.75-.78-1.11L4.57 3.3h2.65l4.97 7.11.77 1.1 6.46 9.25h-2.65l-5.27-7.54Z"
        className={colorClass}
      />
    </svg>
  );
};
